// GA4（gtag.js）へカスタムイベントを送信するユーティリティ。
// gtag.js自体はpublic/index.htmlでグローバルスクリプトとして読み込まれているため、
// ここではwindow.gtagの薄いラッパーを提供するのみで、初期化は行わない。

declare global {
    interface Window {
        gtag?: (...args: unknown[]) => void;
    }
}

export type EventParams = Record<string, string | number | boolean | undefined>;

// GA4カスタムイベントを送信する。window.gtagが未定義（読み込み前・広告ブロッカー等）の場合は何もしない。
export const trackEvent = (eventName: string, params?: EventParams): void => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
        return;
    }
    window.gtag('event', eventName, params);
};
